import {Dot} from 'recharts';

import {isNil} from 'ramda';

import {MY_VEHICLE_COLOR} from '../consts/myVehicleColor';
import {MY_VEHICLE_RADIUS} from '../consts/myVehicleRadius';
import {StatisticsChartItem} from '../types/StatisticsChartItem';

interface MyVehicleShapeProps {
  x?: number; // Passed by recharts
  y?: number; // Passed by recharts
  width?: number; // Passed by recharts
  payload?: StatisticsChartItem;
  chartType: 'scatter' | 'bar';
}

export function MyVehicleShape(props: MyVehicleShapeProps) {
  const isScatterChart = props.chartType === 'scatter';

  if (isNil(props.x) || isNil(props.width) || isNil(props.y)) {
    return null;
  }

  return (
    <Dot
      cx={props.x + props.width / 2}
      cy={props.y + (isScatterChart ? MY_VEHICLE_RADIUS : 0)}
      r={MY_VEHICLE_RADIUS}
      fill={MY_VEHICLE_COLOR}
      stroke={MY_VEHICLE_COLOR}
      strokeOpacity={0.2}
      strokeWidth={16}
      pointerEvents="none"
    />
  );
}
